import { Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

/**
 * Small base with common teardown.
 * Marked as an Angular directive (no selector) so lifecycle hooks are valid.
 */
@Directive()
export abstract class ComponentBase implements OnDestroy {
	/** Emits when the component is destroyed; pipe(takeUntil(this.destroy$)) to auto-unsubscribe. */
	protected readonly destroy$ = new Subject<void>();

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
